
import {isApiTrue}        from "@Common/logic/is-api-true";
import {BlockGuestAccess} from "@Common/logic/block-guest-access";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {cascadeFind}      from "@Common/utils/cascade";
import {isEmpty}          from "@Common/utils/objects";

import {ApplyCreditLine} from "../common/apply-credit-line";
import {FormMode}     from "./form-mode/form-mode";
import {setAdBudgets} from "./set-ad-budgets";

export const AdBudgetSection = ({store, next: rootNext}) => cs(
    consumeContext("company"),
    consumeContext("apis"),
    ["config", (_, next) => next(cascadeFind(store.cart.items, `[*].billingAvailable.adbudget[0]`))],
    ["formMode", ({config}, next) => FormMode({store, config, next})],
    ["blockGuestAccess", (_, next) => BlockGuestAccess({next})],
    ({company, apis, formMode, config, blockGuestAccess}) => {
        if (!config || !isApiTrue(company?.prefs?.adBudgetEnable) || blockGuestAccess) {
            return rootNext({
                available: false,
            });
        }
        if (isEmpty(config.fields)) {
            return rootNext({
                available: true,
                render: () => ApplyCreditLine({
                    label: "Ad Budget",
                    cartAttr: "adBudgets",
                    itemAttr: "adbudget",
                    applyChange: (value) => store.dispatch(setAdBudgets(value, {apis})),
                    store,
                }),
            });
        }

        return rootNext({
            available: true,
            ...formMode,
        });
    },
);
